<article>
  <section class="users">
    <app-page-title label="Organisations" [canGoBack]="true" (click)="goBack()"></app-page-title>
  </section>
  <table class="table" aria-label="users">
    <thead>
      <tr>
        <th style="min-width: 80px">Date<br /></th>
        <th>Time</th>
        <th>
          User
          <br />
          <!-- @todo
          <p-multiSelect [maxSelectedLabels]="1" [options]="users" [(ngModel)]="usersSelected" selectedItemsLabel="{0} selected" (onChange)="userSelectionChanged($event)"> </p-multiSelect>
        --></th>
        <th>Path<br /></th>
      </tr>
    </thead>
    <tbody>
      @for (result of userLog; track result; let i = $index) {
        @if (result.orgId === selectedOrg) {
          <tr>
            <td>
              <span class="isMobile">{{ result.createdAt | date }}</span>
              <span class="isDesktop">{{ result.createdAt | amDateFormat: 'ddd Do' }}</span>
            </td>
            <td>{{ result.createdAt | amDateFormat: 'HH:mm' }}</td>
            <td title="{{ result.path }}">{{ result.userName }}</td>
            @if (result.assetTitle && result.siteTitle) {
              <td class="title">
                <i class="fa fa-fw fa-heartbeat"></i>
                @if (result.path.indexOf('telemetry') >= 0) {
                  <span>Telemetry</span>
                }
                {{ result.siteTitle }} -> {{ result.assetTitle }}
              </td>
            }
            @if (result.assetTitle && !result.siteTitle) {
              <td class="title">
                <i class="fa fa-fw fa-heartbeat"></i>
                @if (result.path.indexOf('telemetry') >= 0) {
                  <span>Telemetry</span>
                }
                {{ result.assetTitle }}
              </td>
            }
            @if (result.siteTitle && result.path.indexOf('live') === -1 && !result.assetTitle) {
              <td class="title">
                <i class="fa fa-fw fa-heartbeat"></i>
                @if (result.path.indexOf('telemetry') >= 0) {
                  <span>Telemetry</span>
                }
                {{ result.siteTitle }}
              </td>
            }
            @if (result.gatewayTitle) {
              <td class="title">
                <i class="fa fa-fw fa-area-chart"></i>
                @if (result.path.indexOf('live') >= 0) {
                  <span>Live</span>
                }
                {{ result.gatewayTitle }}
              </td>
            }
            @if (result.gatewayProfileTitle) {
              <td class="title">
                <i class="fa fa-fw fa-heart"></i>
                @if (result.path.indexOf('profiling')) {
                  <span>Live</span>
                }
                {{ result.gatewayProfileTitle }}
              </td>
            }
            @if (result.reportTitle) {
              <td class="title">
                <i class="fa fa-fw fa-line-chart"></i>
                @if (result.path.indexOf('reports')) {
                  <span>Report</span>
                }
                {{ result.reportTitle }}
              </td>
            }
            @if (result.ruleTitle) {
              <td class="title">
                <i class="fa fa-fw fa-flask"></i>
                @if (result.path.indexOf('rule')) {
                  <span>Rule</span>
                }
                {{ result.ruleTitle }}
              </td>
            }
            @if (!result.reportTitle && !result.gatewayProfileTitle && !result.ruleTitle && !result.gatewayTitle && !result.assetTitle && !result.siteTitle) {
              <td class="title">
                @if (result.title) {
                  <span><i class="fa fa-fw"></i> {{ result.title }}</span>
                }
              </td>
            }
          </tr>
        }
        @if (result.orgId === selectedOrg) {
          <tr>
            <td class="title text-right" colspan="4">
              <span
                ><i class="fa fa-fw"></i>
                <div class="isMobile">{{ result.title }}</div>
                <div style="color: #888" class="isMobile">
                  <a routerLink="{{ result.path }}" target="_blank">{{ result.path }}</a>
                </div>
                <span style="color: #888" class="isDesktop">
                  <a routerLink="{{ result.path }}" target="_blank">{{ result.path }}</a>
                </span>
              </span>
            </td>
          </tr>
        }
      }
    </tbody>
  </table>
  @if (!isFiltering && !loading && userLog.length === 0) {
    <span>No results</span>
  }
</article>
